export enum FeaturePackage {
    CONTENT_PROVIDER = 'content_provider',
    BASE = 'base',
    LOCALIZE = 'localize',
    ANALYZE = 'analyze',
    ENGAGE = 'engage',
}
